import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';
import { TranscribeMode } from '@heidi/schema/ml-scribe';
import { OpenFeature } from '@openfeature/react-sdk';

/**
 * Shows a Dictate-mode session's transcript while the clinician speaks: the
 * recording cuts short chunks, the Transcript tab sits beside the note, and
 * each chunk is rendered from the upload's own response.
 *
 * Off everywhere by default. The on-prem flag bundle turns it on, because the
 * appliance has no streaming transcriber and clinicians there dictate into the
 * session. Non-hook: every reader runs at a recording boundary, not on render.
 */
export const LIVE_DICTATE_TRANSCRIPT_FLAG_KEY = 'release-scribe-live-dictate-transcript';

export const isLiveDictateTranscriptEnabled = (): boolean =>
  OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    LIVE_DICTATE_TRANSCRIPT_FLAG_KEY,
    false
  );

export const isChunkedLiveDictation = (
  mode: TranscribeMode | null | undefined
): boolean => mode === TranscribeMode.DICTATE && isLiveDictateTranscriptEnabled();
